import React from 'react';
import clsx from 'clsx';
import { Button as AriaButton } from 'react-aria-components';

export const Button = ({
  children,
  onClickHandler,
  disabled = false,
  testId,
  variant = 'primary',
}: {
  children: React.ReactNode;
  onClickHandler?: () => void;
  disabled?: boolean;
  testId?: string;
  variant: string;
}) => {
  const buttonStyle = (buttonType: string, isDisabled: boolean) => {
    switch (buttonType) {
      case 'primary':
        return clsx(
          'px-3',
          isDisabled ? 'bg-zinc-300 text-zinc-400' : 'bg-[#F97316] text-white hover:bg-orange-700',
        );
      case 'link':
        return clsx(
          'text-xs font-bold',
          isDisabled ? 'text-zinc-400' : 'text-sky-500 hover:text-sky-700',
        );
      default:
        return clsx('bg-[#F97316] text-white');
    }
  };
  return (
    <AriaButton
      className={({ isDisabled }) =>
        clsx('text-xs font-bold h-9 rounded', buttonStyle(variant, isDisabled))
      }
      isDisabled={disabled}
      onPress={onClickHandler}
      data-cy={testId}>
      {children}
    </AriaButton>
  );
};
